import { render, staticRenderFns } from "./DrawBox.vue?vue&type=template&id=2baf3d96&"
import script from "./DrawBox.vue?vue&type=script&lang=js&"
export * from "./DrawBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports